import React from 'react';
import { Link } from 'react-router-dom';
export function Careers() {
  return <div className="max-w-4xl mx-auto px-6 pt-32 pb-24" data-id="element-7425" data-mp="2dor6r9i3d2c4">
      <div className="mb-16" data-id="element-7426" data-mp="2dpan4ls3fio1">
        <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-7427" data-mp="2dqlpqi9sykdk">
          Join Giga
        </h1>
        <p className="text-neutral-400 font-body text-lg max-w-2xl" data-id="element-7428" data-mp="2mpfk01znuyny">
          We're building an AI assistant platform that connects to every tool
          your team uses. Help us build the future of work.
        </p>
      </div>

      <div className="space-y-12" data-id="element-7429" data-mp="2wmtpj6k1q31h">
        {/* Principal Engineer */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-7430" data-mp="31ebojp2idtjt">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-7431" data-mp="35fxadzx0ti65">
            <div data-id="element-7432" data-mp="35hrnis21w5zo">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-7433" data-mp="3af9sy8gv032x">
                Principal Engineer
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-7434" data-mp="3fdbbmsadi0dv">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-7435" data-mp="1jmkr0gob7nrd">
                  Engineering
                </span>
                <span data-id="element-7436" data-mp="1ep2rfgw6mkw1">•</span>
                <span data-id="element-7437" data-mp="1al3ch2qjvu4s">Remote</span>
                <span data-id="element-7438" data-mp="1amejrcj7fk0n">•</span>
                <span data-id="element-7439" data-mp="1almtmh8dmehr">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-7440" data-mp="15nlci1uigp8x">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-7441" data-mp="1ybqwgmdqqa7p">
            <p data-id="element-7442" data-mp="1tio2we8yr0ri">
              We're looking for a hands-on, senior IC to lead backend
              architecture and systems engineering at Giga. Our product is built
              on Linux VMs (not containers), and uses a custom coding harness
              that interacts directly with operating system primitives.
            </p>

            <div data-id="element-7443" data-mp="2h7yv37c8zmu1">
              <h3 className="text-white font-semibold mb-3" data-id="element-7444" data-mp="306bx3fiw6gd9">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-7445" data-mp="308ekdrsntvea">
                <li data-id="element-7446" data-mp="353tvwd373f7j">
                  Architect and maintain our core backend infrastructure built
                  primarily in Ruby.
                </li>
                <li data-id="element-7447" data-mp="2vf3mig5tsoyi">
                  Manage and optimize our Linux VM fleet and sysadmin
                  operations.
                </li>
                <li data-id="element-7448" data-mp="2hesuvawoz6ca">
                  Build and secure the coding harness that allows our AI agents
                  to execute code safely.
                </li>
                <li data-id="element-7449" data-mp="28fe2u70vmnpo">
                  Navigate and simplify non-straightforward architectural
                  challenges.
                </li>
              </ul>
            </div>

            <div data-id="element-7450" data-mp="6nj6cyn6yps1">
              <h3 className="text-white font-semibold mb-3" data-id="element-7451" data-mp="6mzqdnh3qbgn">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-7452" data-mp="ao34o5ji3zfr">
                <li data-id="element-7453" data-mp="1v7584ct580sf">
                  Deep expertise in Ruby and backend systems architecture.
                </li>
                <li data-id="element-7454" data-mp="1r63goi5gwt10">
                  Strong Linux sysadmin skills and experience managing VM-based
                  infrastructure.
                </li>
                <li data-id="element-7455" data-mp="24y9ongygvtpd">
                  Experience with systems programming and OS-level primitives.
                </li>
                <li data-id="element-7456" data-mp="2ev4i3lfvv3ws">
                  Comfortable working in complex, non-standard architectures.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Head of Product */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-7457" data-mp="2nvkmqy8d4h38">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-7458" data-mp="2iwzimnpzpd9i">
            <div data-id="element-7459" data-mp="thjmc8x5zm11">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-7460" data-mp="th038ovs2rlf">
                Head of Product
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-7461" data-mp="ojrsh9cylpu7">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-7462" data-mp="qy53uj8focx1">
                  Product
                </span>
                <span data-id="element-7463" data-mp="v11pyjx6mr5q">•</span>
                <span data-id="element-7464" data-mp="zybfs0ohh4u3">Remote</span>
                <span data-id="element-7465" data-mp="zzczetjkeznf">•</span>
                <span data-id="element-7466" data-mp="zvyw9j32umex">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-7467" data-mp="14wmmi2jhez83">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-7468" data-mp="c6eev4mknx7r">
            <p data-id="element-7469" data-mp="h5zfdjhe4dml">
              We're looking for a product leader to help us build and maintain a
              software factory where we go from idea to production in less than
              24 hours. You'll shape the direction of our AI assistant platform
              for teams.
            </p>

            <div data-id="element-7470" data-mp="3plstxss5vf10">
              <h3 className="text-white font-semibold mb-3" data-id="element-7471" data-mp="3plan627vhieu">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-7472" data-mp="3i3cl2is0t9ln">
                <li data-id="element-7473" data-mp="3d48c9t90ddvu">
                  Lead product strategy and execution for the Giga platform.
                </li>
                <li data-id="element-7474" data-mp="384ncxhpxf3il">
                  Drive our rapid iteration cycle (idea to production in
                  &lt;24h).
                </li>
                <li data-id="element-7475" data-mp="338y7ixr86sed">
                  Work closely with engineering to define and prioritize
                  features.
                </li>
                <li data-id="element-7476" data-mp="2ue09xdd4urgp">
                  Get your hands dirty — this is a builder role, not just
                  high-level strategy.
                </li>
              </ul>
            </div>

            <div data-id="element-7477" data-mp="2kgm56b0knr48">
              <h3 className="text-white font-semibold mb-3" data-id="element-7478" data-mp="2kh5dd00f7152">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-7479" data-mp="2fghr0rn4z8h6">
                <li data-id="element-7480" data-mp="2bew6ck4d1pwf">
                  You are already AI-native / AI-pilled and deeply understand
                  the current LLM landscape.
                </li>
                <li data-id="element-7481" data-mp="20wnbkg7zke3o">
                  Proven experience shipping complex B2B SaaS products rapidly.
                </li>
                <li data-id="element-7482" data-mp="1rtvykbzgpa9x">
                  Willingness to be hands-on in a fast-paced startup
                  environment.
                </li>
                <li data-id="element-7483" data-mp="1wtibekbdooi7">Strong product intuition and user empathy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}